<template>
  <div>
    <notifications-wrapper position="bottom right" width="20%" />
    <top-navbar is-preview />
    <nuxt />
    <custom-footer />
    <image-zoom-modal />
  </div>
</template>
<script>
import TopNavbar from '@/components/commons/TopNavbar.vue'
import CustomFooter from '@/components/commons/CustomFooter.vue'
import NotificationsWrapper from '@/components/commons/NotificationsWrapper.vue'
import ImageZoomModal from '@/components/commons/ImageZoomModal.vue'

export default {
  components: {
    TopNavbar,
    CustomFooter,
    NotificationsWrapper,
    ImageZoomModal
  },
  middleware: ['redirect_after_login', 'auth', 'check_authorization'],
}
</script>
